var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'btnBox col2':true,'fixedBtn':_vm.fixed}},[(!_vm.disabledBefore)?_c('span',[_c('a',{staticClass:"btnL bGray",on:{"click":_vm.back}},[_vm._v("이전")])]):_vm._e(),_vm._t("default",function(){return [_c('span',[_c('a',{staticClass:"btnL",on:{"click":function($event){return _vm.$emit('submit')}}},[_vm._v("확인")])])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }